import { ITheme } from "../Theme/Theme.types.js";
import { rem } from "../Theme/Theme.constants.js";
import { DefaultSpinnerProps } from "./Spinner.types.js";

export const sizeMap: Record<DefaultSpinnerProps["size"], string> = {
    small: rem(0.75),
    medium: rem(1.25),
    large: rem(2),
};

export const getFillMap = ({ theme }: { theme: ITheme }): Record<DefaultSpinnerProps["color"], string> => ({
    currentColor: "currentColor",
    dark: theme.grayscale[90],
    light: theme.grayscale.white,
    primary: theme.colors.primary[100],
});
